import type { ArticleSection } from '@/mocks/gossip';

interface ArticleBodyProps {
  sections: ArticleSection[];
}

export default function ArticleBody({ sections }: ArticleBodyProps) {
  return (
    <div className="mt-8">
      {sections.map((section, index) => (
        <section key={section.heading || `paragraph-${index}`} id={`section-${index}`} className="scroll-mt-32">
          {section.heading && (
            <h2 className="mt-10 border-l-4 border-primary-500 pl-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {section.heading}
            </h2>
          )}
          {section.paragraphs.map((paragraph, pIndex) => (
            <p
              key={pIndex}
              className="mt-5 text-base leading-loose text-foreground-700 md:text-[17px]"
            >
              {paragraph}
            </p>
          ))}
          {section.quote && (
            <blockquote className="mt-8 rounded-lg bg-accent-50 px-6 py-5">
              <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
              <p className="mt-2 font-heading text-base leading-relaxed text-foreground-900 md:text-lg">
                {section.quote}
              </p>
            </blockquote>
          )}
        </section>
      ))}
    </div>
  );
}